import { render, staticRenderFns } from "./DraggableContainer.vue?vue&type=template&id=0e0667bd&scoped=true&"
import script from "./DraggableContainer.vue?vue&type=script&lang=js&"
export * from "./DraggableContainer.vue?vue&type=script&lang=js&"
import style0 from "./DraggableContainer.vue?vue&type=style&index=0&id=0e0667bd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e0667bd",
  null
  
)

export default component.exports